import {DOCUMENT} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {Component, Inject, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';

@Component({
    selector: 'app-partnerterms',
    templateUrl: './partnerterms.component.html',
    styleUrls: ['./partnerterms.component.css'],
    providers: [ApiServiceService]
})
export class PartnertermsComponent implements OnInit {
    finzyDomain = true;
    otherDomain = false;

    constructor(private route: ActivatedRoute, private ref: ApiServiceService, private router: Router, private storageService: StorageService,
                @Inject(DOCUMENT) private document: any) {
    }

    ngOnInit() {
        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
    }
}
